import {
  TApplicationSetting,
  TApplicationSettingKey,
  TApplicationSettingKeyUserAllowedUpdateKeys,
} from "../applicationSettings"
import { trpc } from "../trpcClient"

export const useApplicationSetting = <T extends TApplicationSettingKey>(
  applicationId: number,
  key: T,
  options?: Parameters<typeof trpc.applications.getApplicationSetting.useQuery>[1]
) => {
  const { data: data_, ...rest } = trpc.applications.getApplicationSetting.useQuery(
    {
      applicationId,
      key,
    },
    {
      suspense: false,
      ...options,
    }
  )
  const data = data_ as Extract<TApplicationSetting, { key: T }>["value"] | null | undefined
  return { data, ...rest }
}

// add in the settings so onSuccess can refetch
export const useUpdateApplicationSetting = (
  applicationId?: number,
  options?: Parameters<typeof trpc.applications.updateApplicationSetting.useMutation>[0]
) => {
  const mutation = trpc.applications.updateApplicationSetting.useMutation(options)
  const { mutateAsync: _mutateAsync, ...rest } = mutation

  const mutateAsync = async <T extends TApplicationSettingKeyUserAllowedUpdateKeys>(
    key: T,
    value: Extract<TApplicationSetting, { key: T }>["value"] | null,
    options?: Parameters<typeof _mutateAsync>[1] & {
      applicationId?: number
    }
  ) => {
    if (applicationId === undefined && options?.applicationId === undefined) {
      throw new Error("applicationId is required")
    }

    return _mutateAsync(
      { applicationId: options?.applicationId || applicationId!, key, value },
      options
    )
  }

  return { mutateAsync, ...rest }
}
